export { default } from './WidgetError';
export * from './WidgetError';
